import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsNotFoundRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsNotFoundRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { NotFound } from './ui/not-found/index.tsx';

export const helpCenterSettingsNotFoundRouteEntry: Route = createEntry(
	helpCenterSettingsNotFoundRoute,
	() => ({
		group: 'customer-service',
		// eslint-disable-next-line no-restricted-syntax
		component: NotFound,
		resources: [...jiraSpaResources()],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
